
export class GlobalConstants {


  //72.139.57.34

   // public static apiURL: string = "http://tcrm.watchnetinc.com/api";
     //public static apiURL: string = "https://localhost:44346/api";
  public static siteTitle: string = "This is example of ItSolutionStuff.com";

  public static constCountryCanada : string  = "CA";
  public static constCountryUSA : string  = "US";

  public static constStatusStandby: string = "SS";
  public static constStatusClose: string = "CC";
  public static constStatusApproved:string = "AP";
  public static constStatusShipped:string = "SP";
  public static constStatusArrived:string = "AR";
  public static constStatusTested:string = "TT";
  public static constStatusShippedBack:string = "SB";
  public static constStatusCreditApproved:string = "CA";
  public static constStatusInventoryReturn:string = "IR";
  public static constStatusDeclined:string = "DD";

  public static constRmaTypeNA: string ="NA"; // not assigned
  public static constRmaTypeAR: string ="AR";
  public static constRmaTypeRR: string ="RR";
  public static constRmaTypeRN: string ="RN";
  public static constRmaTypeCR: string ="CR";
  public static constRmaTypeSR: string ="SR";  //stock rotation

  public static constUserTypeClient: string ="C";
  public static constUserTypeDealer: string ="D";

  public static constPositionTypeNA : string = "NA";
  public static constPositionTypeManager : string = "MG";
  public static constPositionTypeTechnician : string = "TE";
  public static constPositionTypeOwner : string = "OW";

  public static constPositionArray : string[] =
  [
      GlobalConstants.constPositionTypeNA,
      GlobalConstants.constPositionTypeManager,
      GlobalConstants.constPositionTypeTechnician,
      GlobalConstants.constPositionTypeOwner
  ];

  public static constCountryArray : string[] =
  [
    GlobalConstants.constCountryCanada,
    GlobalConstants.constCountryUSA
  ];

  public static constRmaTypeArrayForDealer : string[] =
  [
    GlobalConstants.constRmaTypeAR,
    GlobalConstants.constRmaTypeRR,
    GlobalConstants.constRmaTypeRN,
    GlobalConstants.constRmaTypeCR,
    GlobalConstants.constRmaTypeSR
  ];

  public static constRmaTypeArrayForClient : string[] =
  [
    GlobalConstants.constRmaTypeAR,
    GlobalConstants.constRmaTypeRN,
    GlobalConstants.constRmaTypeCR,
  ];

  public static constStatusNA : string[] =
  [
    GlobalConstants.constStatusStandby,
    GlobalConstants.constStatusApproved,
    GlobalConstants.constStatusClose
  ];

  public static constStatusAR : string[] =
  [
    GlobalConstants.constStatusStandby,
    GlobalConstants.constStatusApproved,
    GlobalConstants.constStatusShipped,
    GlobalConstants.constStatusArrived,
    GlobalConstants.constStatusTested,
    GlobalConstants.constStatusInventoryReturn,
    GlobalConstants.constStatusClose
  ];
  public static constStatusRN : string[] =
  [
    GlobalConstants.constStatusStandby,
    GlobalConstants.constStatusApproved,
    GlobalConstants.constStatusArrived,
    GlobalConstants.constStatusTested,
    GlobalConstants.constStatusShippedBack,
    GlobalConstants.constStatusClose
  ];
  public static constStatusRR : string[] =
  [
    GlobalConstants.constStatusStandby,
    GlobalConstants.constStatusApproved,
    GlobalConstants.constStatusArrived,
    GlobalConstants.constStatusTested,
    GlobalConstants.constStatusShippedBack,
    GlobalConstants.constStatusClose
  ];

  public static constStatusCR : string[] =
  [
    GlobalConstants.constStatusStandby,
    GlobalConstants.constStatusApproved,
    GlobalConstants.constStatusArrived,
    GlobalConstants.constStatusTested,
    GlobalConstants.constStatusCreditApproved,
    GlobalConstants.constStatusInventoryReturn,
    GlobalConstants.constStatusClose
  ];

  public static constStatusSR : string[] =
  [
    GlobalConstants.constStatusStandby,
    GlobalConstants.constStatusApproved,
    GlobalConstants.constStatusArrived,
    GlobalConstants.constStatusCreditApproved,
    GlobalConstants.constStatusInventoryReturn,
    GlobalConstants.constStatusClose
  ];

  public static constUserTypeArray : string[] =
  [
    GlobalConstants.constUserTypeClient,
    GlobalConstants.constUserTypeDealer
  ];

  public static isStockRotationType(type)
  {
    return (type == this.constRmaTypeSR);
  }

  public static isStandBy(status)
  {
    return (status == null || this.constStatusStandby == status)
  }

  public static isApproved(status)
  {
    return (this.constStatusApproved == status)
  }
  public static isClosed(status)
  {
    return (this.constStatusClose == status)
  }
  public static isDeclined(status)
  {
    return (this.constStatusDeclined == status)
  }

  public static isTested(status)
  {
    return (this.constStatusTested == status)
  }
  public static isArrived(status)
  {
    return (this.constStatusArrived == status)
  }

  public static isClientUser(type)
  {
    return (this.constUserTypeClient == type)
  }

  public static isClientDealer(type)
  {
    return (this.constUserTypeDealer == type)
  }


  public static getPositionString(type)
  {
      var typeString = "";
      switch(type)
      {
        case this.constPositionTypeManager:
          typeString = "Manager";
          break;
        case this.constPositionTypeTechnician:
          typeString = "Technicial";
          break;
        case this.constPositionTypeOwner:
          typeString = "Owner";
          break;
        default:
          typeString = "N/A";
          break;
      }

      return typeString;
  }

  public static getCountryString(code)
  {
      var countryString = "";
      switch(code)
      {
          case this.constCountryCanada:
            countryString = "Canada";
              break;

          case this.constCountryUSA:
            countryString = "USA";
              break;

        }

      return countryString;
  }


  public static getCustomerString(type)
  {
      var typeString = "";
      switch(type)
      {
          case this.constUserTypeClient:
            typeString = "Client";
              break;

          case this.constUserTypeDealer:
            typeString = "Dealer";
              break;

        }

      return typeString;
  }

  public static getRmaTypeString(type)
  {
      var typeString = "";
      switch(type)
      {

          case this.constRmaTypeNA:
            typeString = "Not Assigned";
            break;
          case this.constRmaTypeAR:
            typeString = "Advanced Replacement";
              break;
          case this.constRmaTypeRN:
                typeString = "Repair/Replace and Return";
              break;
          case this.constRmaTypeRR:
                typeString = "Repair/Replace, Repack as New and Return";
              break;
          case this.constRmaTypeCR:
                typeString = "Returning for Credit";
              break;
          case this.constRmaTypeSR:
                typeString = "Stock Rotation";
              break;
          default:
            typeString = "Not Assigned";
            break;

      }

      return typeString;
  }

  public static getStatusString(status)
  {
      var statusString = "";
      switch(status)
      {
          case this.constStatusStandby:
              statusString = "Stand By";
              break;
          case this.constStatusClose:
              statusString = "Closed";
              break;
          case this.constStatusApproved:
              statusString = "Approved";
              break;
          case this.constStatusDeclined:
              statusString = "Declined";
              break;
          case this.constStatusShipped:
              statusString = "Advanced Shipped";
              break;
          case this.constStatusArrived:
              statusString = "Package Arrived";
              break;
          case this.constStatusTested:
              statusString = "Tested & Repaired";
              break;
          case this.constStatusShippedBack:
              statusString = "Shipped Back";
              break;
          case this.constStatusCreditApproved:
              statusString = "Credit Approved";
              break;
          case this.constStatusInventoryReturn:
              statusString = "Inventory Return";
              break;
        }

      return statusString;
  }

  public static getStatusColor(status)
  {
      var colorString = "";
      switch(status)
      {
          case this.constStatusStandby:
            colorString = "";
              break;

          case this.constStatusClose:
            //colorString = "alert";
              colorString = "closed";
              break;

          case this.constStatusApproved:
            colorString = "success";
                break;
          case this.constStatusDeclined:
            colorString = "warn";
            break;
          case this.constStatusShipped:
            colorString = "shipped";
              break;
          case this.constStatusArrived:
            colorString = "arrived";
              break;
          case this.constStatusTested:
            colorString = "tested";
              break;
          case this.constStatusShippedBack:
            colorString = "shippedback";
              break;
          case this.constStatusCreditApproved:
            colorString = "credit";
              break;
          case this.constStatusInventoryReturn:
            colorString = "inventoryreturn";
              break;
        }

      return colorString;
  }

  private static getProcessArray(type)
  {
    var processArray : string[];

    switch(type)
    {
      case this.constRmaTypeNA:
        processArray  = this.constStatusNA;
        break;
      case this.constRmaTypeAR:
        processArray  = this.constStatusAR;
        break;
      case this.constRmaTypeRR:
        processArray  = this.constStatusRR;
        break;
      case this.constRmaTypeRN:
        processArray  = this.constStatusRN;
        break;
      case this.constRmaTypeCR:
        processArray  = this.constStatusCR;
        break;
      case this.constRmaTypeSR:
        processArray  = this.constStatusSR;
        break;
    }
    return processArray;
  }

  public static getNextProcessStatus(type, status)
  {
      var processArray = this.getProcessArray(type);

      if(processArray == null || processArray.length == 0) return "";

      var index = processArray.indexOf(status);

      if(index + 1>= processArray.length) return "";

      return processArray[index + 1];
  }

  public static getNextProcessStatusString(type, status)
  {
      var nextstatus= this.getNextProcessStatus(type, status);
      var processString = "";

      switch(nextstatus)
      {
          case this.constStatusApproved:
              processString = "Would you like to approve this request?";
              break;
          case this.constStatusClose:
              processString = "Are you sure you want to close this request?";
              break;
          case this.constStatusShipped:
              processString = "Has the package been shipped in advance?";
              break;
          case this.constStatusArrived:
              processString = "Has the package arrived?";
              break;
          case this.constStatusTested:
              processString = "Have the products been inspected and repaired?";
              break;
          case this.constStatusShippedBack:
              processString = "Has the package been shipped?";
              break;
          case this.constStatusCreditApproved:
              processString = "Has the credit been approved?";
              break;
          case this.constStatusInventoryReturn:
              processString = "Have the products returned to the inventory?";
              break;
          default:
            processString = "Would you like to approve this request?";
            break;
          }

      return processString;
  }




}
